
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[category]",
      function () {
        return require("private-next-pages/menu/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[category]"])
      });
    }
  